const FormatProperCase = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export default FormatProperCase;
